import { render, staticRenderFns } from "./a-student-questionnaire.vue?vue&type=template&id=fe0e7fa2&"
import script from "./a-student-questionnaire.vue?vue&type=script&lang=js&"
export * from "./a-student-questionnaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports